"use client";
import { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";

import Rohit from "../../../assets/images/client/rohit.png";
import Aditi from "../../../assets/images/client/aditi.png";
import Prashanth from "../../../assets/images/client/prashanth.png";
import Varshini from "../../../assets/images/client/varshini.png";
import Vishal from "../../../assets/images/client/vishal.png";
import Test3 from "../../../assets/images/client/test3.png";

export default function Testimonials() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const testimonials = [
        {
            id: 1,
            rating: 5,
            text: '"Neowave Studio transformed our online presence completely. Their SEO-optimized website brought us 3x more inquiries within the first month. The team was professional and delivered beyond expectations!"',
            name: "Rajesh Kumar",
            role: "Business Owner",
            image: Rohit,
        },
        {
            id: 2,
            rating: 5,
            text: '"Outstanding work on our e-commerce platform! Sales increased by 200% after launch. The design is beautiful and the site runs flawlessly. Highly recommend Neowave Studio!"',
            name: "Priya Sharma",
            role: "E-commerce Entrepreneur",
            image: Aditi,
        },
        {
            id: 3,
            rating: 5,
            text: '"The Discord bot they built for our community is incredible. Automated everything we needed and more. Great communication throughout the project!"',
            name: "Amit Patel",
            role: "Community Manager",
            image: Prashanth,
        },
        {
            id: 4,
            rating: 5,
            text: '"Best decision we made was hiring Neowave Studio for our portfolio website. Clean design, fast loading, and mobile-responsive. Our client inquiries doubled!"',
            name: "Sneha Reddy",
            role: "Freelance Designer",
            image: Varshini,
        },
        {
            id: 5,
            rating: 5,
            text: '"Professional team that delivered our business website on time and within budget. The SEO optimization really works—we\'re ranking on Google\'s first page now!"',
            name: "Vikram Singh",
            role: "Startup Founder",
            image: Vishal,
        },
        {
            id: 6,
            rating: 5,
            text: '"Exceptional UI/UX design! Our app users love the new interface. Neowave Studio understood our vision perfectly and brought it to life beautifully."',
            name: "Alenxdra",
            role: "Product Manager",
            image: Test3,
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) =>
                    prevIndex >= testimonials.length - 1 ? 0 : prevIndex + 1
                );
                setIsTransitioning(false);
            }, 500);
        }, 4000);

        return () => clearInterval(interval);
    }, [testimonials.length]);

    const getVisibleTestimonials = () => {
        const visible = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % testimonials.length;
            visible.push(testimonials[index]);
        }
        return visible;
    };

    const visibleTestimonials = getVisibleTestimonials();

    return (
        <section className="relative overflow-hidden bg-black text-white py-24 px-5 lg:px-10">
            <div className="relative z-10 max-w-[90%] mx-auto">
                {/* Header */}
                <div className="text-center mb-16">
                    <Fade triggerOnce>
                        <p className="h8 mb-4">TESTIMONIALS</p>
                        <h2 className="text-[30px] leading-[42px] md:text-[40px] md:leading-[50px] xl:text-[60px] xl:leading-[72px] mb-6">
                            Meet The Clients Who Love Our Work!
                        </h2>
                        <p className="text-[18px] leading-[27px] md:text-[20px] md:leading-[30px] text-gray-400 max-w-6xl mx-auto">
                            We work with diverse industries including technology
                            startups, e-commerce, education, healthcare,
                            hospitality, real estate, restaurants, and local
                            businesses across India—helping them dominate search
                            rankings, drive targeted traffic, and accelerate
                            revenue growth through our proven SEO-optimized
                            websites and digital solutions.
                        </p>
                    </Fade>
                </div>

                {/* Testimonials Grid */}
                <div className="relative overflow-hidden">
                    <div
                        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-500 ${
                            isTransitioning
                                ? "opacity-0 transform translate-x-10"
                                : "opacity-100 transform translate-x-0"
                        }`}
                    >
                        {visibleTestimonials.map((testimonial, index) => (
                            <div
                                key={`${currentIndex}-${index}`}
                                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 h-full flex flex-col"
                            >
                                {/* Stars */}
                                <div className="flex gap-1 mb-4">
                                    {[...Array(testimonial.rating)].map(
                                        (_, i) => (
                                            <svg
                                                key={i}
                                                className="w-5 h-5 text-yellow-400 fill-current"
                                                viewBox="0 0 20 20"
                                            >
                                                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                                            </svg>
                                        )
                                    )}
                                </div>

                                {/* Testimonial Text */}
                                <p className="text-gray-300 text-[16px] leading-[24px] mb-6 flex-grow">
                                    {testimonial.text}
                                </p>

                                {/* Author */}
                                <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                                    <div className="relative w-12 h-12 rounded-full overflow-hidden ">
                                        <img
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            fill
                                            className="object-cover rounded-full w-12 h-12"
                                        />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-white text-[18px]">
                                            {testimonial.name}
                                        </h4>
                                        <p className="text-sm text-gray-400">
                                            {testimonial.role}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}